module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAASAQMAAAB/11zgAAAABlBMVEUAAAD///+l2Z/dAAAAAXRSTlMAQObYZgAAAEtJREFUCB0FwbENwjAQAMAjFGkimQ2yBp0XQ/ofzaMkGyDRpIj83HlZeFv5aGnah9KHyEgxKvWz2H+TVjdrXTzry6MO1EAkItFh4w/B/xoFE8NhMAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/groups/group_icon_arow_avg_event_rank.png
// module id = 700
// module chunks = 0